import moment from "moment";
import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const returnReship = async (data) => {
  try {
    return await postRequest(urls.RETURN_RESHIP, data);
  } catch (err) {
    return err;
  }
};

export const buildReturnReshipPayload = ({ ticketDetails, cspDetails, action, returnReason = "", returnSubReason = "", addressPayload = null }) => {
  const basePayload = {
    workticketId: ticketDetails?.ticketId || "",
    action,
    returnReason,
    returnSubReason,
    createdBy: `${cspDetails?.firstName} ${cspDetails?.lastName}`,
    createdByEmail: cspDetails?.email,
    createdByEid: cspDetails?.Employee_ID,
    assignTo: cspDetails?.Employee_ID,
    assignedTo: cspDetails.CSP[0].CSPOwner,
    assignedToEmail: cspDetails.CSP[0].CSPOwnerEmail,
    assignedToEid: cspDetails.CSP[0].CSPOwnerEId,
    erpProductRecipientPartyId: cspDetails?.ResellerBusinessPartnerNumber || cspDetails?.ERP_Partner_Number,
    erpBusinessPartnerId: cspDetails?.ResellerBusinessPartnerNumber || cspDetails?.ERP_Partner_Number,
    erpTicketType: ticketDetails?.erpTicketType || "ZINS",
    distributionChannel: ticketDetails?.distributionChannel || "02",
    division: ticketDetails?.division || "02",
    requestDate: moment().format("YYYYMMDD"),
    crmReferenceId: ticketDetails?.crmReferenceId || "",
    documentType: "ZINS",
    documentDate: moment().format("YYYYMMDD"),
    salesOrg: "9001",
    contractAccount: ticketDetails?.contractAccount || "",
    addressOne: addressPayload?.address.address1 || ticketDetails?.addressOne || "",
    addressTwo: addressPayload?.address.address2 || ticketDetails?.addressTwo || "",
    city: addressPayload?.address.city || ticketDetails?.city || "",
    stateCode: addressPayload?.address.stateCode || ticketDetails?.stateCode || "",
    country: addressPayload?.address.country || ticketDetails?.country || "USA",
    zipCode: addressPayload?.address.zipCode || ticketDetails?.zipCode || "",
    contactName: addressPayload?.contact.customerName || ticketDetails?.contactName || "",
    contactPhone: addressPayload?.contact.customerPhone || ticketDetails?.phone || "",
    contactEmail: addressPayload?.contact.customerEmail || ticketDetails?.email || "",
    oldDeliveryNo: ticketDetails?.oldDeliveryNo || "",
    cspId: cspDetails.CSP[0].CSPID,
    partners: [
      {
        party: cspDetails?.ResellerBusinessPartnerNumber || cspDetails?.ERP_Partner_Number || "",
        partRoleCode: "AG",
      },
      {
        party: cspDetails?.ERP_Primary_Contact_NUmber ?? "",
        partRoleCode: "AP",
      },
      {
        party: cspDetails?.ERP_Partner_Number,
        partRoleCode: "WE",
        accountName: cspDetails?.AccountName,
        contactName: ticketDetails?.contactName || "",
        contactPhone: ticketDetails?.phone || "",
        contactEmail: ticketDetails?.email || "",
        street: ticketDetails?.addressOne || "",
        city: ticketDetails?.city || "",
        state: ticketDetails?.stateCode || "",
        country: ticketDetails?.country || "USA",
        zip: ticketDetails?.zipCode || "",
      },
    ],
  };

  return basePayload;
};
